"use strict";
import orderView from "emun.order/order-view";
import orderContainer from "emun.order/order-container";
import orderDetails from "emun.order/order-details";
import orderHeaderFieldset from "emun.order/order-header-fieldset";
import orderDetailsHeader from "emun.order/order-details-header";
import orderDetailsTabs from "emun.order/order-details-tabs";
import orderDetailsTopNav from "emun.order/order-details-top-nav";
import orderDetailsLines from "emun.order/order-details-lines";
import orderDetailsShop from "emun.order/order-details-shop";
import orderDetailsActions from "emun.order/order-details-actions";
import orderDetailsCatalogs from "emun.order/order-details-catalogs";
import orderDetailsInvoices from "emun.order/order-details-invoices";
import orderDetailsChangeNotices from "emun.order/order-details-change-notices";
import orderList from "emun.order/order-list";
import orderListGrid from "emun.order/order-list-grid";
import orderListCards from "emun.order/order-list-cards";
import inactiveOrdersList from "emun.order/inactive-orders/inactive-orders-list";
import inactiveOrdersListGrid from "emun.order/inactive-orders/inactive-orders-list-grid";
import modifiedOrdersList from "emun.order/modify-order/modified-orders-list";
import modifiedOrdersListGrid from "emun.order/modify-order/modified-orders-list-grid";
import backordersList from "emun.order/backorders/backorders-list";
import backordersListGrid from "emun.order/backorders/backorders-list-grid";
// import commitmentsList from "emun.order/commitments/commitments-list";
// import commitmentsListGrid from "emun.order/commitments/commitments-list-grid";
// import interestsList from "emun.order/interests/interests-list";
// import interestsListGrid from "emun.order/interests/interests-list-grid";
import vendorReviewOrdersList from "emun.order/vendor-review-orders/vendor-review-orders-list";
import reviewOrdersList from "emun.order/review-orders/review-orders-list";
// import orderQuickViewPopover from "emun.order/order-quick-view.popover.htm";
import orderQuickView from "emun.order/order-quick-view";
import orderQueryCriteria from "emun.order/order-query-criteria";
import orderToc from "emun.order/order-toc";
import emailOrderPrompt from "emun.order/email-order-prompt.directive";
import partsOrderModule from "emun.order/parts/parts-order.module";
import changeNoticeModule from "emun.order/change-notices/change-notice.module";
import { extendModule } from "ng";
import ticket from "emun.order/ticket";
import ticketFieldset from "emun.order/ticket-fieldset";
import ticketOrder from "emun.order/ticket-order";
import ticketContainer from "emun.order/ticket-container";
import ticketList from "emun.order/ticket-list";
import ticketListTable from "emun.order/ticket-list-table";
import approveCart from "emun.cart/approve-cart/approve-cart";
//import sharedCart from "emun.cart/shared-cart/shared-cart";
import enterPayment from "emun.cart/enter-payment/enter-payment";
import guestCheckout from "emun.cart/guest-checkout/guest-checkout";
import recentlyViewedOrdersDropdown from "emun.order/recently-viewed/recently-viewed-orders-dropdown";
import orderNotes from 'emun.order/order-notes';
import orderNotesPopup from 'emun.order/order-notes-popup';
import orderNotePrompt from 'emun.order/order-note-prompt';
import orderNotePromptDirective from 'emun.order/order-note-directive';
import trackingInfo from 'emun.order/tracking/tracking-info';
import termsList from 'emun.order/terms/terms-list';
import notesList from 'emun.order/notes/note-list';
import orderDetailsVendorInvoices from 'emun.order/order-details-vendor-invoices'

const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const app = angular
  .module("emun.order", deps)
  .component("orderContainer", orderContainer)
  .directive("emailOrderPrompt", emailOrderPrompt)
  .directive("orderList", orderList)
  .directive("orderListGrid", orderListGrid)
  .directive("orderListCards", orderListCards)
  .component("inactiveOrdersList", inactiveOrdersList)
  .directive("inactiveOrdersListGrid", inactiveOrdersListGrid)
	.component("modifiedOrdersList", modifiedOrdersList)
	.directive("modifiedOrdersListGrid", modifiedOrdersListGrid)
	.component("backordersList", backordersList)
	.directive("backordersListGrid", backordersListGrid)
	// .component("commitmentsList", commitmentsList)
	// .directive("commitmentsListGrid", commitmentsListGrid)
	// .component("interestsList", interestsList)
	// .directive("interestsListGrid", interestsListGrid)
	.component("vendorReviewOrdersList", vendorReviewOrdersList)
	.component("reviewOrdersList", reviewOrdersList)
  .component("orderView", orderView)
  .component("orderDetails", orderDetails)
  .directive("orderDetailsTopNav", orderDetailsTopNav)
  .component("orderDetailsHeader", orderDetailsHeader)
  .directive("orderDetailsLines", orderDetailsLines)
  .directive("orderDetailsVendorinvoices", orderDetailsVendorInvoices)
  .directive("orderDetailsShop", orderDetailsShop)
  .directive("orderDetailsCatalogs", orderDetailsCatalogs)
  .directive("orderDetailsInvoices", orderDetailsInvoices)
  .directive("orderDetailsChangeNotices", orderDetailsChangeNotices)
  .directive("orderDetailsActions", orderDetailsActions)
  .component("orderHeaderFieldset", orderHeaderFieldset)
  .component("orderDetailsTabs", orderDetailsTabs)
  .component("orderQuickView", orderQuickView)
  .component("orderQueryCriteria", orderQueryCriteria)
  .component("ticket", ticket)
  .component("ticketFieldset", ticketFieldset)
  .component("ticketOrder", ticketOrder)
  .component("orderToc", orderToc)
  .component("ticketContainer", ticketContainer)
  .component("ticketList", ticketList)
  .component("ticketListTable", ticketListTable)
  .component("recentlyViewedOrdersDropdown", recentlyViewedOrdersDropdown)
  .component("approveCart", approveCart)
//  .component("sharedCart", sharedCart)
	.component("enterPayment", enterPayment)
	.component("guestCheckout", guestCheckout)
	.component('orderNotes', orderNotes)
	.component('trackingInfo', trackingInfo)
	.component('orderNotesPopup', orderNotesPopup)
	.component('termsList', termsList)
  .directive('orderNotePrompt', orderNotePromptDirective)
  .component('notesList', notesList);
extendModule(app, partsOrderModule, changeNoticeModule);

export default app.name;
